import { membershipHubURL } from '../../common/urls';

export default function ForgotPasswordRedirect() {
  window.location.replace(membershipHubURL('/request-password-reset'));
  return null;
}
